import type { Field } from "~/types/api";

export const areOptionsEqual = (
  options1: Field["options"],
  options2: Field["options"]
): boolean => {
  if (!options1 && !options2) return true;
  if (!options1 || !options2) return false;
  if (options1.length !== options2.length) return false;
  if (options1.length === 0) return true;

  const map1 = new Map(options1.map((opt) => [opt.value, opt.default]));
  const map2 = new Map(options2.map((opt) => [opt.value, opt.default]));

  if (map1.size !== map2.size) return false;

  for (const [value, defaultValue] of map1) {
    if (map2.get(value) !== defaultValue) return false;
  }
  return true;
};

export const areFieldsEqual = (field1: Field, field2: Field): boolean => {
  if (field1.name !== field2.name) return false;
  if (field1.type !== field2.type) return false;
  if (field1.required !== field2.required) return false;
  if (field1.order !== field2.order) return false;
  return areOptionsEqual(field1.options, field2.options);
};
